export default __webpack_public_path__ + "static/media/2025_Magee_et_al_2025_EcologyLetters.29765f60.pdf";